import { Suspense } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { FallbackLoader } from './components/layout/FallbackLoader'
import { GlobalStyle } from './components/layout/GlobalStyle'
import { AuthProvider } from './context/Auth'
import { ConfigProvider } from './context/Config'
import { DialogsProvider } from './packages/context/Dialogs'
import { Routes } from './routes/configuration'
import { Config } from './types/config'
import 'moment/locale/it'

type Props = {
  config: Config
}

const queryClient = new QueryClient({ defaultOptions: { queries: { useErrorBoundary: false } } })

const AppComponent = ({ config }: Props) => {
  return (
    <GlobalStyle>
      <ToastContainer
        closeOnClick
        draggable
        hideProgressBar={false}
        newestOnTop={false}
        pauseOnFocusLoss
        pauseOnHover
        position="top-right"
        rtl={false}
      />
      <ConfigProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <Suspense fallback={<FallbackLoader />}>
            <BrowserRouter>
              <DialogsProvider>
                <AuthProvider>
                  <Routes />
                </AuthProvider>
              </DialogsProvider>
            </BrowserRouter>
          </Suspense>
        </QueryClientProvider>
      </ConfigProvider>
    </GlobalStyle>
  )
}

export const App = (config: Config) => () => <AppComponent config={config} />
